import querystring from 'querystring';
import { SocialMediaType } from '@/shared/enums';
import { AssetLoader } from '@/shared/utils';
import GtmEmitter from './gtm-emitter';

const isSsoLogin = () => {
  const { code, error } = querystring.parse(window.location.href.split('?')[1]);
  const isLoginPage = /\/subscriber\/login/.test(window.location.href);
  return isLoginPage && (code || error);
};

export default async ({ $services, $stats, $storage }) => {
  const info = $services.resolve('info');
  const liveManager = $services.resolve('liveManager');
  const subscriber = $services.resolve('subscriber');

  await info.fetch();
  const googleAnalyticsToken = info.googleAnalyticsToken;

  if (!googleAnalyticsToken) {
    return;
  }

  if ($storage.socialMedia === SocialMediaType.FACEBOOK && isSsoLogin()) {
    window.dataLayer = [{
      pageCategory: 'signup',
      visitorType: 'high-value',
      visitorLoginState: 'Logged in FB',
    }];
  } else {
    window.dataLayer = window.dataLayer || [];
  }

  window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
  const emitter = new GtmEmitter($stats, subscriber, liveManager);
  $stats.registerEmitter(emitter);

  new AssetLoader().load([
    { id: 'gtm', src: `//www.googletagmanager.com/gtm.js?id=${googleAnalyticsToken}` },
  ], { async: true })
    .then(() => {
      emitter.activate();
    })
    .catch(() => {});
};
